import type { DesignSystemComponentKey } from '../theme/scopeDesignSystem';

export const TOGGLE_BUTTON_GROUP_FIELD_DESIGN_SYSTEM_KEYS = [
  'MuiToggleButton',
  'MuiToggleButtonGroup',
] as const satisfies readonly DesignSystemComponentKey[];
